import { render } from "./ITableTh.vue?vue&type=template&id=321b3880"
import script from "./ITableTh.vue?vue&type=script&lang=js"
export * from "./ITableTh.vue?vue&type=script&lang=js"

import "./ITableTh.vue?vue&type=style&index=0&id=321b3880&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__